import '../App.css';

var About = () => {
  return (
    <>
      <h3 className="h3-1">What is an Impact Key?</h3>
      <p>
        Impact Keys are a collection of onchain digital assets that connect economic activity on the
        blockchain directly to charitable giving. Each token carries a permanent, on-chain record
        of the causes it supports and a live tally of the total value it has raised &mdash; a new
        kind of asset that becomes more meaningful with use.
      </p>

      <h3 className="h3-1">How it works</h3>
      <p>
        Impact Keys are NFTs where each token is permanently linked to a set of charitable causes.
        When you own one, any value it generates automatically flows to those causes &mdash; it&#39;s
        built into how the token works, not a separate donation step. The first collection (EM0)
        supports four categories:
      </p>
      <div className="cause-list">
        <div className="cause-item">
          <div className="cause-label">PEOPLE</div>
          <div className="cause-desc">Human welfare, health, and economic opportunity</div>
        </div>
        <div className="cause-item">
          <div className="cause-label">ATMOSPHERE</div>
          <div className="cause-desc">Air quality, climate stability, and atmospheric ecosystems</div>
        </div>
        <div className="cause-item">
          <div className="cause-label">EARTH</div>
          <div className="cause-desc">Land conservation, soil health, and terrestrial biodiversity</div>
        </div>
        <div className="cause-item">
          <div className="cause-label">WATER</div>
          <div className="cause-desc">Ocean and freshwater health, marine ecosystems, and access to clean water</div>
        </div>
      </div>

      <h3 className="h3-1">Built for composability</h3>
      <p>
        Impact Keys are intentionally minimal. Each token&#39;s on-chain data is a compact,
        well-defined set of attributes: the charitable allocation percentages for each cause
        category, and a running total of the value raised for charity through that specific token.
      </p>
      <p>
        This minimalism is a design principle. Impact Keys don&#39;t prescribe what they should
        look like, what context they should appear in, or what kind of experience should surround
        them. They are open primitives. Any developer, artist, game designer, or platform builder
        can read these attributes and build any experience they want on top of them &mdash;
        without permission and without dependency on any proprietary ecosystem.
      </p>

      <h3 className="h3-1">Gamified impact</h3>
      <p>
        Each Impact Key maintains a live stat &mdash; Total Value Raised (TVR) &mdash; that
        increases permanently as donations flow through it over its lifetime. This creates a
        compounding, on-chain record of real-world impact that grows with use. The more an
        Impact Key participates in transactions and experiences, the more meaningful it becomes.
        A high-TVR token is a verifiable signal of real-world contribution.
      </p>

      <h3 className="h3-1">Incentives for builders</h3>
      <p>
        Developers and creators who build experiences on top of Impact Keys participate in the
        same economic structure as the tokens themselves. The royalty mechanism is transparent
        and on-chain: anyone who drives value through the tokens benefits proportionally. The
        incentive to build is directly aligned with the incentive to generate charitable impact.
      </p>

      <h3 className="h3-1">Technical overview</h3>
      <p>
        Impact Keys are ERC-1155 tokens deployed on Ethereum mainnet. Each token&#39;s charitable
        allocation percentages are generated at mint time using an on-chain randomization
        mechanism, making every token&#39;s cause weighting unique. The contract is fully open
        and on-chain attributes are readable by any external system. IK0 is limited to a supply
        of 11,888 tokens.
      </p>
    </>
  );
};

export default About;
